<template>
  <div class="header">
    <div class="top_header">
    <div class="top_header_con">
      <img class="top_logo" src="@/assets/images/newLogo.png" />
      <img class="top_line" src="@/assets/images/line.png" />
      <div class="top_nav">
        <div class="navfont2" @click="goTo('/')" :class="[activeMenu === '/' ? 'active' : '']">
          <a>首页</a>
        </div>
        <div
          class="navfont2"
          @click="goTo('/newIndex')"
          :class="[activeMenu === '/newIndex' ? 'active' : '']"
        >
          <a>最新消息</a>
        </div>
        <div
          class="navfont2"
          :class="[activeMenu === '/performs' ? 'active' : '']"
        >
          <a>演出与购票</a>
          <div class="nav_ul">
            <a
              v-for="(item, index) in programList"
              :key="index"
              @click="goTo('/performs', item.name, item.id)"
              >{{ item.name }}</a
            >
          </div>
        </div>
        <div
          class="navfont2"
          @click="goTo('/program')"
          :class="[activeMenu === '/program' ? 'active' : '']"
        >
          <a>往期节目单</a>
        </div>
        <div
          class="navfont2"
          @click="goTo('/facilities')"
          :class="[activeMenu === '/facilities' ? 'active' : '']"
        >
          <a>场地设施与租赁</a>
        </div>
        <div
          class="navfont2"
          :class="
            activeMenu === '/member/login' ||
            activeMenu === '/member/activityList' ||
            activeMenu === '/member/ruler'
              ? 'active'
              : ''
          "
        >
          <a @click="goTo('/member/login', 1)">会员专区</a>
          <div class="nav_ul">
            <a @click="goTo('/member/login', 1)">会员中心</a>
            <a>
              会员活动
              <div class="nav_ul copy_li">
                <a
                  v-for="(item, index) in memberList"
                  :key="index"
                  @click="goTo('/member/activityList', index, item.id)"
                  >{{ item.name }}</a
                >
              </div>
            </a>
            <a @click="goTo('/member/ruler', 2)">会员制度与权益</a>
          </div>
        </div>
        <div
          class="navfont2"
          @click="goTo('/connection')"
          :class="[activeMenu === '/connection' ? 'active' : '']"
        >
          <a>联系我们</a>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getselectList, gethelpList, getmemberlist } from "../network/home";
export default {
  data() {
    return {
      zh_CN: true,
      zh_TW: false,
      en_US: false,
      programList: [],
      helpList: [],
      memberList: [],
      activeMenu: ""
    };
  },
  mounted() {
    if (sessionStorage.getItem("classIndx")) {
      this.activeMenu = sessionStorage.getItem("classIndx");
    }
    this.getProgram();
    this.getHelpCenter();
    this.getmemberactivity();
  },
  methods: {
    //切换语音
    changeLanguage(id) {},
    goTo(url, index, id) {
      console.log(url,index,id);
      this.activeMenu = url;
      console.log(this.activeMenu);
      sessionStorage.setItem("classIndx", this.activeMenu);
      this.$router
        .push({ path: url, query: { indexs: index, id: id } })
        .catch(err => {
          if (err.name !== "NavigationDuplicated") {
            throw err;
          }
        });
    },
    // 获取节目类型下来列表
    async getProgram() {
      try {
        let res = await getselectList();
        this.programList = res.data;
        return res;
      } catch (e) {
        console.log(e);
      }
    },
    //获取帮助中心
    async getHelpCenter() {
      try {
        let res = await gethelpList({
          clientType: 1
        });
        this.helpList = res.data;
        return res;
      } catch (e) {
        console.log(e);
      }
    },
    //会员活动
    async getmemberactivity() {
      try {
        let res = await getmemberlist({
          clientType: 1
        });
        this.memberList = res.data;
        return res;
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>
<style scoped>
.header {
  width: 100%;
  height: 140px;
  position: relative;
}

.header_nav {
  width: 960px;
}

.navfont2 {
  float: left;
  min-width: 120px;
  cursor: pointer;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.navfont2 > i {
  width: 20px;
  height: 20px;
  display: inline-block;
  margin-left: 5px;
  margin-top: 3px;
  float: left;
}

.navfont2:hover > a {
  /* color: #ffffff !important; */
  /* color: rgba(255, 255, 255, 0.5); */
}

.navfont2:hover > i {
  background: url("../assets/images/pic_04.png") no-repeat;
}

.navfont2:hover > .nav_ul {
  display: block;
}

.language {
  position: absolute;
  bottom: 12px;
  right: 10px;
  height: 25px;
}

.language span {
  line-height: 14px;
  width: 60px;
  display: inline-block;
  font-size: 13px;
  transition: all 0.15s ease-out;
  text-decoration: none;
  cursor: pointer;
}

.language .active {
  color: #e3c728 !important;
}

.nav_ul {
  margin: 0;
  padding: 0;
  width: 140px;
  position: absolute;
  top: 35px;
  left: 0;
  z-index: 9999;
  background: #ffffff;
  display: none;
  /* border-radius: 15px; */
}

.nav_ul a {
  color: #000;
  width: 115px;
  text-decoration: none;
  display: inline-block;
  padding: 7px 13px;
  text-align: center;
  line-height: 20px;
  font-family: OPPOSans, OPPOSans;
  font-weight: 400;
  font-size: 16px;
  position: relative;
}

.nav_ul a:hover {
  background: #f7f4f0 !important;
  color: #755a39;
}
.nav_ul a:hover:first-child {
  /* border-top-left-radius: 15px; */
  /* border-top-right-radius: 15px; */
}

.nav_ul a:hover:last-child {
  /* border-bottom-left-radius: 15px; */
  /* border-bottom-right-radius: 15px; */
}

.nav_ul a:hover > .copy_li {
  display: block;
}

.copy_li {
  background: #baafb3 !important;
  left: 140px !important;
  top: 0px !important;
}
/* ////////////// */
.top_header {
  width: 100%;
  height: 140px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99;
  background-color: #000;
}
.top_header_con{
  width: 100%;
  max-width: 1440px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  padding: 0 20px;
  box-sizing: border-box;
}

.top_logo {
  width: 220px;
  height: 88px;
  margin-right: 50px;
}
.top_line {
  margin-right: 50px;
}
.navfont2 {
  float: left;
  min-width: 120px;
  cursor: pointer;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-right: 10px;
  font-weight: 800;
  font-size: 18px;
  color: #ffffff;
  /* transition: color 0.3s; */
}
.active {
  color: rgba(255, 255, 255, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue